export const version = '1.0.0';
export const port = 8080;
export const examUrl = {
  toefl: 'ti-toefl.smartstudy.com',
  ielts: 'ti-ielts.smartstudy.com',
  gre: 'ti-gre.smartstudy.com',
  base: 'ti-base.smartstudy.com',
  base2: 'ti-base2.smartstudy.com',
  jikaoSat: 'ti-sat.smartstudy.com',
};

export const apiUrl = 'https://api.smartstudy.com/tiku';



// WEBPACK FOOTER //
// ./src/common/config.js